import React, { useEffect } from "react";
import { connect } from "react-redux";
import { defineMessages, useIntl } from "react-intl";
import { Select, Form } from "antd";
import PropTypes from "prop-types";

import { selectors as CONNECTION_SELECTORS } from "../../../ducks/node";
import { selectors as LOADING_SELECTORS } from "../../../ducks/loadingData";

import WebsocketManager from "../../../services/websocket";

import { required } from "../../../lib/utils/formValidation";
import { LOADING_DATA_TYPE } from "../../../lib/utils/constants";

const { Option } = Select;

const { Item } = Form;

const translations = defineMessages({
  networkInterfaceLabel: {
    id: "NetworkField.label",
    defaultMessage: "Network Interface",
  },
  auto: {
    id: "general.auto",
    defaultMessage: "Automatic",
  },
});

const NetworkField = ({ cwid, name, interfaces, label, loading, loadingDataType, requiredField }) => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    const loadInterfaces = (isConnection) => {
      const getInterfaces = () => {
        WebsocketManager.sendMessage(
          JSON.stringify({ cloudMsgType: "sendMessage", command: "getInterfaces", to: cwid })
        );
      };

      if (isConnection) getInterfaces();
    };

    const isConnection = cwid;
    loadInterfaces(isConnection);
  }, [cwid]);

  const parsedInterfaces = interfaces.map((config) => ({
    label: `${config.ip}`,
    value: `${config.ip}`,
  }));

  const autoInterface = { label: formatMessage(translations.auto), value: "Automatic" };
  const defaultInterfaces = [autoInterface, ...parsedInterfaces];

  const isLoadingNetworkInterfaces = loading && loadingDataType === `${name}-${LOADING_DATA_TYPE.networkInterfaces}`;

  return (
    <Item
      name={name}
      label={label || formatMessage(translations.networkInterfaceLabel)}
      {...(requiredField ? { rules: [{ ...required }] } : {})}
    >
      <Select loading={isLoadingNetworkInterfaces}>
        {defaultInterfaces.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Item>
  );
};

NetworkField.propTypes = {
  cwid: PropTypes.string.isRequired,
  interfaces: PropTypes.arrayOf(
    PropTypes.shape({
      ip: PropTypes.string.isRequired,
      mac: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]).isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  loading: PropTypes.bool.isRequired,
  loadingDataType: PropTypes.string.isRequired,
  requiredField: PropTypes.bool,
};

NetworkField.defaultProps = {
  label: "Network Interface",
  requiredField: true,
};

const mapStateToProps = (state) => ({
  cwid: CONNECTION_SELECTORS.getNodeCwid(state),
  interfaces: CONNECTION_SELECTORS.getNetworkInterfaces(state),
  loading: LOADING_SELECTORS.getLoading(state),
  loadingDataType: LOADING_SELECTORS.getLoadingDataType(state),
});

export default connect(mapStateToProps, null)(NetworkField);
